export default __webpack_public_path__ + "static/media/stepper.144b555e.svg";